import type { FieldErrors, UseFormHandleSubmit, UseFormRegister } from 'react-hook-form-latest';

import { MAX_CAGE_POPULATION } from '@/constants/cage';
import { _isEmpty } from '@/littledash';

import type { RecagingAnimal } from '../Recaging.utils';
import { CAGE_NAMING_METHODS } from '../Recaging.utils';

interface RecagingFormData {
  per_cage: number;
  sequencePrefix: string;
  sequenceStarting: string;
}

interface CageGenerationFormProps {
  register: UseFormRegister<RecagingFormData>;
  errors: FieldErrors<RecagingFormData>;
  handleSubmit: UseFormHandleSubmit<RecagingFormData>;
  onSubmit: () => void;
  cageNamingMethod: string;
  onCageNamingMethodChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  loading: boolean;
  studyCagesLoading: boolean;
  selectedSubjects: RecagingAnimal[];
}

export const CageGenerationForm: React.FC<CageGenerationFormProps> = ({
  register,
  errors,
  handleSubmit,
  onSubmit,
  cageNamingMethod,
  onCageNamingMethodChange,
  loading,
  studyCagesLoading,
  selectedSubjects,
}) => {
  return (
    <div className="ui-card w-40 mr4 pa3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <h3 className="lh-solid f4 pb3">Generate cages</h3>
        <div>
          <div className="flex flex-row">
            <div className="mr3">
              <label htmlFor="per_cage">Name cages using</label>
              <select
                name="cage_name_generation"
                disabled={loading && studyCagesLoading}
                onChange={onCageNamingMethodChange}
                value={cageNamingMethod}
                data-testid="cage_name_generation"
              >
                {CAGE_NAMING_METHODS.map(({ value, label }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mr3">
              <label htmlFor="per_cage">Animals per cage</label>
              <div className="flex flex-row">
                <input
                  type="number"
                  style={{ marginBottom: 0, marginRight: '10px', width: '50px' }}
                  className={errors.per_cage ? 'input__error mr1' : ''}
                  {...register('per_cage', {
                    required: true,
                    validate: (value) => {
                      if (isNaN(value)) {
                        return false;
                      }
                      if (value <= 0) {
                        return 'Minimum animals per cage is 1';
                      }
                      if (value > MAX_CAGE_POPULATION) {
                        return `Maximum animals per cage is ${MAX_CAGE_POPULATION}`;
                      }
                    },
                  })}
                />
                <button
                  className="w-100 mb3 w-auto-ns mb0-ns plain"
                  type="submit"
                  data-testid="generate-cages"
                  disabled={!_isEmpty(errors) || _isEmpty(selectedSubjects) || loading || studyCagesLoading}
                >
                  Generate
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
